import { message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Form, FormGroup, Modal, ModalBody, Spinner } from "reactstrap";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  ExchangeRateTable,
  Icon,
  PaginationComponent,
  RSelect,
} from "../../../components/Component";
import { authHeader } from "../../../header";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { useForm } from "react-hook-form";
import { Card } from "reactstrap";
import { statusOptions } from "../options_common";
import { useDebounce } from "../../../hooks/useDebounceSearch";
import { AllowAccess } from "../../../components/BlockAccess";

export const ExchangeRateManagement = () => {
  const [modal, setModal] = useState({
    edit: false,
    add: false,
    view: false,
  });
  const [editId, setEditedId] = useState();
  const [formData, setFormData] = useState({
    sellingPrice: 0,
    name: "",
    status: "",
    buyingPrice: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [ExchangeRate, setExchangeRate] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadBtn, setIsLoadBtn] = useState(false);
  const [, setDetails] = useState({});
  const [currencies, setCurrencies] = useState();
  const [search, setSearch] = useState("");

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const debouncedSearchTerm = useDebounce(search, 500);
  
  useEffect(
    () => {
      // if (debouncedSearchTerm) {
      getAllExchangeRates();
      setCurrentPage(1);
      // }v
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
    setFormData({
      sellingPrice: 0,
      name: "",
      status: "",
      buyingPrice: 0,
    });
  };

  const onFormCancel = () => {
    setModal({ edit: false, add: false });
    resetForm();
    getAllExchangeRates();
  };

  const getAllCurrencies = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trcurrency`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      const filteredCurrencies = resultData.filter((data) => data.status === "ACTIVE");
      if (resultData) {
        setCurrencies(filteredCurrencies);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getAllExchangeRates = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trexchange-rates?search=${search}`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      if (resultData) {
        setExchangeRate(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const addExchangeRate = async (obj) => {
    try {
      setIsLoadBtn(true);
      setIsLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/admin/trexchange-rates`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getAllExchangeRates();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ add: false });
        message.success({
          content: "Exchange Rate Created",
          style: {
            marginTop: "20vh",
          },
        });
        resetForm();
      }
      return { formData };
    } catch (error) {
      const message = await error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ add: false });
      message.error({
        content: message.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      resetForm();
      return { message };
    }
  };

  const editExchangeRate = async (obj) => {
    try {
      setIsLoading(true);
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/auth/admin/trexchange-rates/${editId}`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getAllExchangeRates();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ edit: false });
        message.success({
          content: "Exchange Rate Updated Successfully",
          style: {
            marginTop: "20vh",
          },
        });
        resetForm();
      }
      return { formData };
    } catch (error) {
      const message = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ edit: false });
      message.error({
        content: message.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      resetForm();
      return { message };
    }
  };

  const deleteExchangeRate = async () => {
    try {
      setIsLoading(true);
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/auth/admin/trexchange-rates/${formData.id}`,
        {
          headers: authHeader(),
        }
      );
      const data = await response.data;
      if (data) {
        getAllExchangeRates();
        message.success({
          content: "Exchange Rate Deleted Successfully",
          style: {
            marginTop: "20vh",
          },
        });
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ delete: false });
        resetForm();
      }
      return { data };
    } catch (error) {
      const message = error.response;
      message.success({
        content: "Failed to delete Exchange Rate",
        style: {
          marginTop: "20vh",
        },
      });
      setIsLoadBtn(false);
      setIsLoading(false);
      getAllExchangeRates();
      setModal({ delete: false });
      resetForm();
    }
  };

  const onFormSubmit = () => {
    addExchangeRate(formData);
    resetForm();
    // setModal({ add: false });
  };

  const onDeleteClick = (items) => {
    setModal({ delete: true });
    setFormData({
      id: items.id,
    });
  };

  const onEditSubmit = () => {
    editExchangeRate(formData);
    resetForm();
    // setModal({ edit: false });
  };

  const onEditClick = async (items) => {
    setModal({ edit: true });
    setFormData({
      name: items.name,
      status: items.status,
      sellingPrice: items.sellingPrice,
      buyingPrice: items.buyingPrice,
      id: items.id,
    });
    setDetails(items);
    setEditedId(items.id);
  };

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = ExchangeRate?.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    getAllExchangeRates();
    getAllCurrencies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const currencyOptions =
    currencies?.map((curr) => ({
      value: curr.name,
      label: curr.name,
    })) ?? [];

  return (
    <React.Fragment>
      <Head title="Exchange Rate Management" />
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Exchange Rate</BlockTitle>
                <div className="d-flex align-items-center justify-center">
                  <div className="mr-2">
                    <input
                      className="form-control"
                      value={search}
                      onChange={handleSearchChange}
                      placeholder="Search Exchange Rate..."
                    />
                  </div>
                  <AllowAccess allowedRights={["CREATE_EXCHANGE_RATE"]}>
                    <Button color="primary" onClick={() => setModal({ add: true })}>
                      <Icon name="plus" />
                      <span>Add Rate</span>
                    </Button>
                  </AllowAccess>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <ExchangeRateTable 
                exchangeRate={currentItems}
                modal={modal}
                onEditClick={onEditClick}
                handleView={() => setModal({ view: true })}
                handleDel={onDeleteClick}
              />
            )}
          </Card>
          <div className="card-inner">
            {ExchangeRate && ExchangeRate.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={ExchangeRate.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No exchange rate found</span>
              </div>
            )}
          </div>
        </Block>

        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Add Exchange Rate</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Rate Name</label>
                      <RSelect
                        options={currencyOptions}
                        onChange={(e) => setFormData({ ...formData, name: e.value })}
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        options={statusOptions}
                        placeholder="Select Status"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      />

                      {errors.status && <span className="invalid">{errors.status.message}</span>}
                      {/* <label className="form-label">Currency</label>
                      <RSelect options="" onChange={(e) => setFormData({ ...formData, status: e.value })} /> */}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Buying Price</label>
                      <input
                        type="number"
                        step="any"
                        name="buyingPrice"
                        // value={formData.buyingPrice}
                        placeholder="0.00"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.buyingPrice && <span className="invalid">{errors.buyingPrice.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Selling Price</label>
                      <input
                        type="number"
                        step="any"
                        name="sellingPrice"
                        // value={formData.sellingPrice}
                        placeholder="0.00"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.sellingPrice && <span className="invalid">{errors.sellingPrice.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button color="primary" size="md" type="submit">
                            Add Exchange rate
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Edit Exchange Rate</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Rate Name</label>
                      <RSelect
                        options={currencyOptions}
                        value={currencyOptions.filter(({ value }) => value === formData.name)}
                        onChange={(e) => setFormData({ ...formData, name: e.value })}
                      />
                      {errors.title && <span className="invalid">{errors.title.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        value={statusOptions.find((d) => d.value === String(formData.status))}
                        options={statusOptions}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Buying Price</label>
                      <input
                        type="number"
                        step="any"
                        name="buyingPrice"
                        value={formData.buyingPrice}
                        placeholder="0.00"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.buyingPrice && <span className="invalid">{errors.buyingPrice.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Selling Price</label>
                      <input
                        type="number"
                        step="any"
                        name="sellingPrice"
                        value={formData.sellingPrice}
                        placeholder="0.00"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.sellingPrice && <span className="invalid">{errors.sellingPrice.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button color="primary" size="md" type="submit">
                            Update
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={modal.delete}
          toggle={() => setModal({ delete: false })}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Delete Exchange Rate</h5>
              <div className="mt-4">
                <Button onClick={deleteExchangeRate} color="danger" size="lg">
                  Delete
                </Button>
                <Button onClick={onFormCancel} className="ml-2" color="secondary" size="lg">
                  Cancel
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};
